import React, { useEffect } from "react";
import { GiCheckMark } from "react-icons/gi";

const TentangKami: React.FC = () => {
  const IconVerif = GiCheckMark as React.FC<React.SVGProps<SVGSVGElement>>;

  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("opacity-100", "translate-y-0", "transition-all", "duration-700", "ease-out");
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section id="tentang" className="pt-16 pb-20 max-sm:px-4 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* ================= TENTANG KAMI ================= */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center mb-16">
          {/* KONTEN */}
          <div>
            <div className="mb-6 reveal opacity-0 translate-y-10">
              <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 max-sm:text-center">
                Tentang <span className="text-primary">Kami</span>
              </h1>
              <div className="border-b-2 border-primary w-[50%] hidden md:block mt-2"></div>
            </div>

            <h2 className="reveal opacity-0 translate-y-10 delay-[100ms] md:text-2xl font-bold text-gray-800 mb-4 max-sm:text-center">Gerakan Pengawalan Pembangunan Nasional</h2>

            <p className="reveal opacity-0 translate-y-10 delay-[200ms] text-gray-600 text-base md:text-lg leading-relaxed text-justify">
              <span className="font-semibold text-gray-800">Merah Putih 08</span> merupakan transformasi dari gerakan relawan yang sebelumnya aktif dalam momentum Pemilihan Umum 2024. Berawal dari kekuatan akar rumput, gerakan ini
              berkembang menjadi organisasi yang lebih terstruktur dan strategis.
            </p>

            <p className="reveal opacity-0 translate-y-10 delay-[300ms] text-gray-600 text-base md:text-lg leading-relaxed mt-5 text-justify">
              Saat ini, Merah Putih 08 berkomitmen untuk mengawal program pembangunan nasional, memperkuat komunikasi publik, serta memastikan setiap agenda pemerintah dapat dipahami dan dirasakan manfaatnya oleh seluruh masyarakat
              Indonesia.
            </p>

            {/* POINT */}
            <div className="mt-6 space-y-4 text-base md:text-base">
              <div className="reveal opacity-0 translate-y-10 delay-[400ms] flex items-start gap-3">
                <IconVerif className="text-primary mt-1 text-xl" />
                <div className="text-gray-700">
                  <strong>Pengawalan Program Nasional</strong> – Mendukung dan mengawal implementasi kebijakan pemerintah agar berjalan efektif dan tepat sasaran.
                </div>
              </div>

              <div className="reveal opacity-0 translate-y-10 delay-[500ms] flex items-start gap-3">
                <IconVerif className="text-primary mt-1 text-xl" />
                <div className="text-gray-700">
                  <strong>Edukasi & Komunikasi Publik</strong> – Menyampaikan informasi yang jelas kepada masyarakat terkait program prioritas nasional.
                </div>
              </div>

              <div className="reveal opacity-0 translate-y-10 delay-[600ms] flex items-start gap-3">
                <IconVerif className="text-primary mt-1 text-xl" />
                <div className="text-gray-700">
                  <strong>Gerakan Nasionalisme</strong> – Menguatkan semangat persatuan dan partisipasi masyarakat dalam pembangunan Indonesia.
                </div>
              </div>
            </div>
          </div>

          {/* GAMBAR */}
          <div className="relative mx-auto reveal opacity-0 translate-y-10 delay-[300ms]">
            <img src="/images/prabowo.png" alt="Tentang Kami" className="h-96 md:h-[470px] object-cover  transition-transform duration-700 hover:scale-105" />
          </div>
        </div>

        {/* ================= VISI & MISI ================= */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {/* VISI */}
          <div className="reveal opacity-0 translate-y-10">
            <h2 className="text-3xl md:text-4xl font-extrabold text-primary mb-6">VISI</h2>
            <p className="text-base md:text-lg text-gray-700">Menjadi organisasi strategis dalam mengawal pembangunan nasional yang berkelanjutan dan berorientasi pada kesejahteraan rakyat.</p>
          </div>

          {/* MISI */}
          <div>
            <h2 className="reveal opacity-0 translate-y-10 text-3xl md:text-4xl font-extrabold text-gray-900 mb-6">MISI</h2>

            <div className="space-y-4 text-base md:text-base">
              <div className="reveal opacity-0 translate-y-10 delay-[100ms] flex gap-3">
                <IconVerif className="text-primary mt-1 text-xl" />
                <div className="text-gray-700">Mengawal dan mendukung program prioritas pemerintah secara aktif dan berkelanjutan.</div>
              </div>

              <div className="reveal opacity-0 translate-y-10 delay-[200ms] flex gap-3">
                <IconVerif className="text-primary mt-1 text-xl" />
                <div className="text-gray-700">Membangun komunikasi publik yang transparan dan edukatif kepada masyarakat.</div>
              </div>

              <div className="reveal opacity-0 translate-y-10 delay-[300ms] flex gap-3">
                <IconVerif className="text-primary mt-1 text-xl" />
                <div className="text-gray-700">Menggerakkan partisipasi masyarakat dalam mendukung pembangunan nasional.</div>
              </div>

              <div className="reveal opacity-0 translate-y-10 delay-[400ms] flex gap-3">
                <IconVerif className="text-primary mt-1 text-xl" />
                <div className="text-gray-700">Menjaga stabilitas sosial melalui kolaborasi dan semangat persatuan.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TentangKami;
